import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import {
  Chip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  CircularProgress,
  Box
} from '@mui/material';
import { useGetRevertOrgViewChange } from 'hooks/useOrganizationNewHooks';
import { useNavigate } from 'react-router-dom';
import { toastConfig } from 'utils/commonUtil';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

const ViewOrganizationSection = () => {
  const theme = useTheme();
  const [openDialog, setOpenDialog] = useState(false);
  const userData = JSON.parse(localStorage.getItem('userData'));
  // console.log('🚀 ~ ViewOrganizationSection ~ userData:', userData);
  const { isPending: isDeleteOrg, mutateAsync: deleteOrgAsync } = useGetRevertOrgViewChange();
  // console.log('🚀 ~ ViewOrganizationSection ~ isDeleteOrg:', isDeleteOrg);

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleDeleteClick = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirmDelete = async () => {
    await deleteOrgAsync(userData?.id, {
      onSuccess: (res) => {
        if (res?.status === 200) {
          toastConfig.type = 'success';
          localStorage.setItem('userJwtToken', res?.data?.data?.token);
          // localStorage.setItem(
          //   'userJwtToken',
          //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY3N2U2OGJkOTY3YzE1ZjdhYzE1MzA3YiIsInR5cGVzIjpbIk1haW4gUE9DIiwiU2Vjb25kYXJ5IFBPQyJdLCJvcmdhbml6YXRpb25UeXBlcyI6WyJTdXBlckFkbWluIiwiRW50ZXJwcmlzZSIsIlJlY3ljbGVyIiwiUmV0YWlsZXIiLCJSZXNlbGxlciIsIlNlcnZpY2VQcm92aWRlciJdLCJpYXQiOjE3NDQ2MTkyMDMsImV4cCI6MTc3NjE3NjgwM30.uF8HmRmtIYttXii6PURhF6oxjffaKcAS2uKRlJVF0CQ'
          // );
          localStorage.setItem('userData', JSON.stringify(res?.data?.data?.user));
          localStorage.setItem('userOrgId', JSON.stringify(res?.data?.data?.user?.id));
          // localStorage.removeItem('viewChangeOrgName', JSON.stringify(res?.data?.data?.user?.orgName));
          localStorage.setItem('isViewChange', 0);
          const organizationTypes = res?.data?.data?.user?.organizationTypes;
          const userTypes = res?.data?.data?.user?.types;

          localStorage.setItem(
            'orgType',
            organizationTypes && Array.isArray(organizationTypes) && organizationTypes.length > 0 ? organizationTypes[0] : null
          );
          localStorage.setItem('userType', userTypes && Array.isArray(userTypes) && userTypes.length > 0 ? userTypes[0] : null);
          navigate('/dashboard/default');
        }
        queryClient.invalidateQueries(['getProfileDataById']);
        localStorage.removeItem('viewChangeOrgName', JSON.stringify(res?.data?.data?.user?.orgName));
      },
      onError: (error) => {
        console.error('Error reverting organization view:', error);
      }
    });
    setOpenDialog(false);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(loading);
    }, 2000);
  }, []);
  return (
    <>
      <Chip
        className="fg"
        sx={{
          borderRadius: '27px',
          transition: 'all .2s ease-in-out',
          borderColor: theme.palette.primary.light,
          backgroundColor: theme.palette.primary.light,
          '&:hover': {
            backgroundColor: 'inherit',
            borderColor: 'inherit'
          },
          '& .MuiChip-label': {
            color: 'black',
            transition: 'color 0.2s ease-in-out',
            '&:hover': {
              color: 'black !important'
            }
          }
        }}
        label={
          <Typography variant="h5" sx={{ color: 'black' }}>
            You are viewing : <span style={{ fontWeight: '700' }}>{userData?.orgName}</span>
          </Typography>
        }
        variant="outlined"
        color="primary"
        deleteIcon={<CloseIcon sx={{ color: 'red', fontSize: 20 }} />}
        onDelete={handleDeleteClick}
      />

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth={false}
        fullScreen={false}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        className="dlte_file_mdlnw machine-settings"
      >
        <DialogTitle
          id="alert-dialog-title"
          variant="span"
          style={{
            textTransform: 'capitalize'
          }}
        >
          Revert Organization View
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to revert back from{' '}
            <span style={{ fontSize: '14px', fontWeight: '600', color: '#364152' }}>{userData?.orgName}</span>?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Box sx={{ m: 1, position: 'relative' }}>
            <Button
              fullWidth
              variant="contained"
              type="submit"
              onClick={handleConfirmDelete}
              style={{
                color: '#fff'
              }}
              color="primary"
              disabled={isDeleteOrg}
            >
              Yes
              {isDeleteOrg && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: '#16B1FF',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px'
                  }}
                />
              )}
            </Button>
          </Box>
          <Button variant="outlined" type="reset" color="error" onClick={handleCloseDialog}>
            Cancel
          </Button>
        </DialogActions>

        {/* <DialogActions>
          <Box sx={{ m: 1, position: 'relative' }}>
            <Button fullWidth variant="contained" onClick={handleConfirmDelete} color="primary" disabled={isDeleteOrg}>
              {isDeleteOrg ? 'Processing...' : 'Yes'}
            </Button>
            {isDeleteOrg && (
              <CircularProgress
                size={24}
                sx={{
                  color: '#fff',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  marginTop: '-12px',
                  marginLeft: '-12px',
                  zIndex: 1
                }}
              />
            )}
          </Box>

          <Button variant="outlined" type="reset" color="error" onClick={handleCloseDialog}>
            Cancel
          </Button>
        </DialogActions> */}
      </Dialog>
    </>
  );
};

export default ViewOrganizationSection;
